import Vue from 'vue';
import VueTreeselect from '@riophae/vue-treeselect';
// import the styles
import '@riophae/vue-treeselect/dist/vue-treeselect.css';
Vue.component('treeselect', VueTreeselect);
